export const palette = {
  secondary_blue2: '#4292ff',
};
